import type { AuctionCarTransaction } from "@/types/auctions";
import type { DefaultMantineColor } from "@mantine/core";

export function getColorFromTransitionStatus(
  status?: AuctionCarTransaction["status"] | AuctionCarTransaction["result"]
): DefaultMantineColor {
  switch (status) {
    case "for_sale":
    case "not_sold":
      return "green";
    case "expired":
    case "not_available":
    case "sold_at_auction":
    case "sold":
      return "red";
    case "upcoming_auction":
    case "upcoming":
      return "yellow";
    case "unknown":
    default:
      return "gray";
  }
}
